import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function UvodUPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Uvod u pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Uvod u pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Uvod u pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Uvod u pravo ima za cilj izučavanje države i prava kao
                objektivno datih pojava u svijetu a ne proučava konkretnu državu
                i konkretno pravo. Zbog toga spada u apstraktne pravne predmete
                jer pručava državu i pravo uopšte a ne neku konkretnu državu i
                konkretno pravo. Takođe cilj predmeta Uvod u pravo je da se
                studenti upoznaju sa pravom kao sistemom društvenih pravila
                pojmom prane norme i pravnog odnosa i njihovom primjenom kao i
                sa principima na kojima počiva pravo.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Ovaj predmet proučava strukturalne elemente države i prava koje
                susrećemo u svakoj državi i svakom pravu. Ishod proučavanja je
                da se spoznaju država i pravo njihova priroda i uzajamni odnosi.
                Nauke koje se bave proučavanjem konkretnog prava i konkretne
                države nazivaju se konkretnim pravnim naukama. Neki od tih
                najopštijih pojmova su: pojam države, pojam i vrste državnih
                organa, državni oblici. Pojam pravne norme, pravnog akta i
                pravnog odnosa. Takođe sa znajima stečenim iz predmeta Uvod u
                pravo studenti će biti osposobljeni da primjereno koriste
                osnovne pravne pojmove definišu elemente pravne norme utvrde
                važeću pravnu normu kao i da pristupe izučavanju konkretnih
                pravnih nauka. Izučavanjem ovog predmeta studenti će ovladati
                osnovama pozitivno pravnih disciplina: Ustavnog, Građanskog,
                Krivičnog prava itd. i tako se pripremiti za detaljnije
                proučavanje ovih i drugih pravnih disciplina tokom nastavka
                studija.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>Pojam predmet i metod Uvoda u pravo</li>
                <li>Međusobni uticaj država-pravo</li>
                <li>Pojam prava i teorije o pravu</li>
                <li>Pojam države (Porijeklo i funkcija države)</li>
                <li>
                  Pravna organizacija države; elementi i značaj državne
                  organizacije
                </li>
                <li>Oblici vladavine: monarhija, republika</li>
                <li>Oblici političkog režima: demokratija, autokratija</li>
                <li>
                  Oblici državnog uređenja: konfederacija i federacija, unitarna
                  država
                </li>
                <li>Oblici državne vlasti</li>
                <li>Pojam i sastav pravnog poretka</li>
                <li>
                  Pravna norma; Vrste pravnih normi; Elementi pravne norme
                </li>
                <li>Društvena norma i vrste društvenih normi</li>
                <li>
                  Pojam pravnog akta; Elementi pravnog akta; Sadržina i
                  donošenje pravnog akta
                </li>
                <li>
                  Opšti pravni akti (izvori prava); Vrste formalnih pravnih
                  izvora i njihova hijerarhija
                </li>
                <li>Pojedinačni pravni akti</li>
                <li>Pojam i elementi pravnog odnosa</li>
                <li>Subjekt prava</li>
                <li>Ustavnost, zakonitost, vladavina prava i pravna država</li>
                <li>Primjena prava tumačenje prava i sistem prava</li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vježbe,
                samostalni rad (seminarski rad i interaktivna nastava).
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P</td>
                    <td>
                      Pojam predmet i metod Uvoda u pravo; Međusobni uticaj
                      država-pravo
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P</td>
                    <td>
                      Pojam prava i teorije o pravu; Pojam države (Porijeklo i
                      funkcija države)
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P</td>
                    <td>
                      Pravna organizacija države; elementi i značaj državne
                      organizacije
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P</td>
                    <td>
                      Oblici vladavine: monarhija, republika; Oblici političkog
                      režima: demokratija, autokratija
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P</td>
                    <td>
                      Oblici državnog uređenja: konfederacija i federacija,
                      unitarna država; Oblici državne vlasti
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P</td>
                    <td>Pojam i sastav pravnog poretka</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P</td>
                    <td>
                      Pravna norma; Vrste pravnih normi; Elementi pravne norme;
                      Društvena norma i vrste društvenih normi
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P</td>
                    <td>
                      Pojam pravnog akta; Elementi pravnog akta; Sadržina i
                      donošenje pravnog akta
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P</td>
                    <td>
                      Opšti pravni akti (izvori prava); Vrste formalnih pravnih
                      izvora i njihova hijerarhija
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P</td>
                    <td>Pojedinačni pravni akti</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P</td>
                    <td>Pojam i elementi pravnog odnosa; Subjekt prava</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P</td>
                    <td>
                      Ustavnost, zakonitost, vladavina prava i pravna država
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P</td>
                    <td>Primjena prava tumačenje prava i sistem prava</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4č / 3.00h</td>
                            <td>Ukupno: 80h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4č / 3.00h</td>
                            <td>Nastava + završni ispit: 60h</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 6h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UvodUPravo;
